export const CheckoutContentText =
  'font-medium text-14 leading-16 tracking-0.4 mb-2 last:mb-0'
export const CheckoutBasePriceText =
  'font-normal text-grayRegular text-14 leading-16 tracking-0.4 mb-2 last:mb-0 line-through'
export const CheckoutContentLabel = `${CheckoutContentText} flex items-center justify-between`
export const CheckoutContentDiscountLabel = `text-14 leading-16 flex items-center justify-between`
export const CheckoutContentLabelWithBorder = `${CheckoutContentLabel} border-t border-solid border-black pt-3`
export const CheckoutContentPrice = 'font-bold text-16 leading-24 tracking-0.8'
export const CheckoutFlexCenter = 'flex flex-col justify-center'
export const CheckoutTaxes = 'font-normal text-grayRegular'
export const CheckoutItemsWrapper = 'pt-8 mb-0.5'
export const BigBlackBorder = 'border-b-4 border-solid border-black'
export const ThinBlackBorder = 'mt-0.5 border-b border-solid border-black mb-2'
export const CategoryItemWrapper = 'mb-6'
export const OrderSumaryLineItemWrapper = 'mb-4'
export const OrderSumaryLineItemContent =
  'flex flex-row flex-nowrap border-t border-solid border-t-black mb-2'
export const OrderSumaryLineItemImage = 'max-w-[68px]'
export const OrderSumaryLineItemDetails = 'w-full flex flex-col p-2'
export const OrderSumaryLineItemTitle =
  'font-medium text-16 leading-16 tracking-0.6 mb-1'
export const OrderSummaryLineItemBasketDetails =
  'flex flex-row justify-between mt-1'
export const OrderSumaryLineItemQuantity = 'ml-2'
export const OrderSumaryAvailability = 'items-start'
export const OrderSummaryProductPriceWrapper = 'flex flex-col'
